import React, { useState } from 'react';
import { loadConnectAndInitialize } from '@stripe/connect-js';
import {
  ConnectComponentsProvider,
  ConnectAccountOnboarding,
  ConnectNotificationBanner,
  ConnectPayouts,
} from '@stripe/react-connect-js';
import { bookingApi } from '../utils/bookingApi';

// The page's own colour and font, so Stripe's pieces look like part of the app
function appearance() {
  const css = getComputedStyle(document.documentElement);
  const colour = css.getPropertyValue('--secondary-color').trim() || '#7c35e8';
  return {
    variables: {
      colorPrimary: colour,
      fontFamily: "'Exo 2', Arial, sans-serif",
      borderRadius: '8px',
    },
  };
}

// Stripe's set-up form, notices and payouts for the club's own Stripe account,
// inside the Card payments page. `active` shows payouts instead of the form.
export default function EmbeddedStripe({ active, onFinished }) {
  const [error, setError] = useState(null);
  const [connect] = useState(() => loadConnectAndInitialize({
    publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
    fetchClientSecret: async () => {
      try {
        const res = await bookingApi.payoutsAccountSession();
        return res.data.clientSecret;
      } catch (err) {
        setError(err.response?.data?.error || 'Could not reach Stripe. Please try again.');
        throw err;
      }
    },
    appearance: appearance(),
    fonts: [{ cssSrc: 'https://fonts.googleapis.com/css2?family=Exo+2:wght@400;500;600;700&display=swap' }],
  }));

  return (
    <ConnectComponentsProvider connectInstance={connect}>
      {error && <p className="bk-error">{error}</p>}
      <div style={{ display: 'grid', gap: '1rem' }}>
        <ConnectNotificationBanner />
        {active
          ? <ConnectPayouts />
          : <ConnectAccountOnboarding onExit={onFinished} collectionOptions={{ fields: 'eventually_due' }} />}
      </div>
    </ConnectComponentsProvider>
  );
}
